import React from 'react';

function LinkSeries({ data, selectedSeries, onSeriesChange }) {
    const handleClick = (event) => {
        const series = event.currentTarget.getAttribute('data-series');
        onSeriesChange(series);
    };

    return (
        <div className="all-year">
            {data.map(item => (
                <div
                    className={`year-box ${selectedSeries === item.ID ? 'act' : ''}`}
                    key={item.ID}
                    data-series={item.ID}
                    onClick={handleClick}
                >
                    {item.name}
                </div>
            ))}

            <div
                className={`year-box ${selectedSeries === 'all' ? 'act' : ''}`}
                key="all"
                data-series="all"
                onClick={handleClick}
            >
                Все
            </div>
        </div>
    );
}

export default LinkSeries;